export const methodType = {
  POST: "POST",
  GET: "GET",
  PUT: "PUT",
  DELETE: "DELETE",
};

export const AUTHORIZATION_KEY = "Authorization";
export const CONTENT_TYPE_KEY = "Content-Type";

export const contentType = {
  APPLICATION: "application/json",
  TEXT: "text/json",
  CSV: "text/csv",
  MULTIPART_FORM_DATA: "multipart/form-data",
  URL_ENCODED: "application/x-www-form-urlencoded",
};
